package com.patronat.top.client.presentation.home.model

import com.patronat.top.dto.venues.VenueCategory
import com.patronat.top.dto.venues.VenueGroup
import org.jetbrains.compose.resources.StringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_category_auto
import top.clientapp.generated.resources.client_home_category_business
import top.clientapp.generated.resources.client_home_category_education
import top.clientapp.generated.resources.client_home_category_events
import top.clientapp.generated.resources.client_home_category_beauty
import top.clientapp.generated.resources.client_home_category_food
import top.clientapp.generated.resources.client_home_category_health
import top.clientapp.generated.resources.client_home_category_home
import top.clientapp.generated.resources.client_home_category_household
import top.clientapp.generated.resources.client_home_category_it_media
import top.clientapp.generated.resources.client_home_category_logistics
import top.clientapp.generated.resources.client_home_category_malls
import top.clientapp.generated.resources.client_home_category_markets
import top.clientapp.generated.resources.client_home_category_pets
import top.clientapp.generated.resources.client_home_category_travel

data class HomeCategoryShortcut(
    val id: String,
    val group: VenueGroup,
    val category: VenueCategory?,
    val labelRes: StringResource
)

fun homeCategoryShortcuts(): List<HomeCategoryShortcut> {
    return VenueGroup.entries.map { group ->
        HomeCategoryShortcut(
            id = group.name,
            group = group,
            category = null,
            labelRes = group.homeShortcutLabelRes()
        )
    }
}

private fun VenueGroup.homeShortcutLabelRes(): StringResource = when (this) {
    VenueGroup.FOOD -> Res.string.client_home_category_food
    VenueGroup.SHOPPING -> Res.string.client_home_category_markets
    VenueGroup.BEAUTY -> Res.string.client_home_category_beauty
    VenueGroup.HEALTH -> Res.string.client_home_category_health
    VenueGroup.AUTO -> Res.string.client_home_category_auto
    VenueGroup.HOME -> Res.string.client_home_category_home
    VenueGroup.EDUCATION -> Res.string.client_home_category_education
    VenueGroup.BUSINESS -> Res.string.client_home_category_business
    VenueGroup.IT_MEDIA -> Res.string.client_home_category_it_media
    VenueGroup.LOGISTICS -> Res.string.client_home_category_logistics
    VenueGroup.ENTERTAINMENT -> Res.string.client_home_category_malls
    VenueGroup.PETS -> Res.string.client_home_category_pets
    VenueGroup.HOUSEHOLD -> Res.string.client_home_category_household
    VenueGroup.EVENTS -> Res.string.client_home_category_events
    VenueGroup.TRAVEL -> Res.string.client_home_category_travel
}
